import React, { useState, useEffect } from 'react';
import fetchCourseIntegrations from '../../../services/fetchCourseIntegrations';
import ButtonContainer from '../../../components/ButtonContainer';
import user from '../../../store/user';
import fetchCourseList from '../../../services/fetchCourseList';
import './styles.scss';
import { Header, Modal, Table } from 'semantic-ui-react';
import Loader from '../../../components/Loader';
import CountDisplay from '../../../components/CountDisplay';
import Pagination from '../../../components/Pagination';
import Button from '../../../components/Button';
import Heading from '../../../components/Heading';
import { toast, ToastContainer } from 'react-toastify';
import moment from 'moment';
import { getQueryParams } from "../../../utils/utilFunctions";
import { Link } from 'react-router-dom';
import { coursePlanMap } from '../../../models/coursePlanMap';
import deleteCourse from '../../../services/deleteCourse';
import unpublishCourse from '../../../services/unpublishCourse';
import rejectCourse from '../../../services/rejectCourse';
import deleteCourseBrochure from '../../../services/deleteCourseBrochure';
import Dropdown from '../../../components/Dropdown/Dropdown';
import { rejectReasonsCourse } from '../../../models/rejectReasonsCourse';
import FromToDatepicker from '../../../components/FromToDatepicker';
import fetchLeadsByIntegrations from '../../../services/fetchLeadsByIntegrations';
import fetchCourseByIntegration from '../../../services/fetchCourseByIntegration';

const PAGE_CONTENT = 50;


const LeadsList = (props) => {

    const [content, setContent] = useState({
        list: [],
        count: 0,
        pageNumber: 1
    })

    const [admin, setAdmin] = useState({
        adminId: null,
    })

    const [fetchApiCall, setFetchApiCall] = useState(true)

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [leadsType, setLeadsType] = useState(0);

    // Integration filter state
    const [integration, setIntegration] = useState('0');
    const [courseIntegrations, setCourseIntegrations] = useState({
        list: [],
        map: {}
    });

    // Course filter state
    const [courseId, setCourseId] = useState('0');
    const [courseList, setCourseList] = useState([]);
    useEffect(() => {

        const fetchProfile = async () => {
            return await user.getProfile()
        }
        fetchProfile().then(userData => {
            if (userData.adminType == 2 || userData.adminType == 3 || userData.adminType == 4) {
                setAdmin({
                    adminId: userData.id,
                })
                const queryObj = getQueryParams(props.location.search);
                setContent(prev => ({
                    ...prev,
                    pageNumber: queryObj.pageNumber,
                }));
                let integrationValue=queryObj.integration?queryObj.integration:'0';
                setIntegration(integrationValue);
                let courseIdValue=queryObj.courseId?queryObj.courseId:'0';
                setCourseId(courseIdValue);
                const startDateValue = queryObj.startDate || null;
                const endDateValue = queryObj.endDate || null;
                const leadsTypeValue = queryObj.type || 0;
                setStartDate(startDateValue);
                setEndDate(endDateValue);
                setLeadsType(leadsTypeValue);
                getCourseInterations(userData.id);
                const pgNo = queryObj.pageNumber ? queryObj.pageNumber : 1;

                // Load courses for selected integration (including '0' for all)
                loadCoursesByIntegration(userData.id, integrationValue);

                getCourseList(userData.id, pgNo, integrationValue, startDateValue, endDateValue, leadsTypeValue, courseIdValue);
            } else {
                window.location.href = process.env.REACT_APP_LOGIN_URL;
            }
        });
    }, []);

    // Fetch integration types
    const getCourseInterations = async(adminId) => {
        try{
          const res = await fetchCourseIntegrations(adminId);
          const data = res.data.data.integrations;
          const formattedList = formatIntegration(data);
    
          setCourseIntegrations({
            list: formattedList,
            map: data
          });
        }
        catch(e) {
          console.log(e);
          toast.error('Something went wrong!');
        }
    }

    const formatIntegration = (listMap) => {
        const newList = [];
        newList.push({
            id: '0',
            name: 'Select Integration Type'
        })
        for(const key in listMap) {
            newList.push({
            id: key,
            name: listMap[key]
            })
        }
        return newList;
    }

    // Fetch courses by integration
    const loadCoursesByIntegration = async (adminId, integrationId) => {
        try {
            let courseData = [];
            if(integrationId > 0) {
                const res = await fetchCourseByIntegration(adminId, integrationId, {});
                courseData = res.data.data.data.courses || [];
            }
            const formattedList = formatCourseList(courseData);
            setCourseList(formattedList);
        } catch (e) {
            console.log(e);
            toast.error('Failed to fetch courses for selected integration');
        }
    }

    const formatCourseList = (programs) => {
        const newList = [];
        newList.push({
            id: '0',
            name: 'Select Course'
        });
        programs.forEach(program => {
            newList.push({
                id: program.id.toString(),
                name: program.title
            });
        });
        return newList;
    }


    // Accept filters for integration and courseId
    const getCourseList = async (adminId, pageNumber, integrationValue, startDate, endDate, leadsType, courseIdValue) => {
        setFetchApiCall(true);
        try {
            const filters = {};
            if (startDate) {
                filters.startDate = startDate;
            }
            if (endDate) {
                filters.endDate = endDate;
            }
            if(leadsType==1) {
                filters.onlyRelevant = true;
            }
            if(courseIdValue && courseIdValue != '0') {
                filters.courseId = courseIdValue;
            }
            routeRequest(pageNumber, integrationValue, startDate, endDate, leadsType, courseIdValue);
            const leads = await fetchLeadsByIntegrations(adminId, integrationValue, { ...filters });
            setContent({
                pageNumber: pageNumber,
                list: leads.data.data.leads,
                count: leads.data.data.totalLeads,
            });
            setFetchApiCall(false)
        }
        catch (err) {
            console.log(err);
            toast.error('Failed to fetch leads list.');
            setFetchApiCall(false)
        }
    }


    const handlePageChange = async(n) => {
        await getCourseList(admin.adminId, n, integration, startDate, endDate, leadsType, courseId);
    }


    const routeRequest = (pageNumber, integration, startDate, endDate, leadsType, courseId) => {
        let array = [];
        array.push(`pageNumber=${pageNumber}`);
        if (integration>=0) {
            array.push(`integration=${integration}`);
        }
        if (startDate) {
            array.push(`startDate=${startDate}`);
        }
        if (endDate) {
            array.push(`endDate=${endDate}`);
        }
        if (leadsType) {
            array.push(`leadsType=${leadsType}`);
        }
        array = array.join("&");
        props.history.push("?" + array);
    };
    // Integration filter change handler
    const onChangeFilter = async (event) => {
        const newIntegration = event.target.value;
        setIntegration(newIntegration);
        
        // Reset course selection and load courses for new integration
        setCourseId('0');
        await loadCoursesByIntegration(admin.adminId, newIntegration);
        
        await getCourseList(admin.adminId, 1, newIntegration, startDate, endDate, leadsType, '0');
    }

    // Course filter change handler
    const onChangeCourseFilter = async (event) => {
        const newCourseId = event.target.value;
        setCourseId(newCourseId);
        await getCourseList(admin.adminId, 1, integration, startDate, endDate, leadsType, newCourseId);
    }

    const handleChangeStart = async (date) => {
        const formattedDate = moment(date).format('YYYY-MM-DD');
        setStartDate(formattedDate);
        await getCourseList(admin.adminId, 1, integration, formattedDate, endDate, leadsType, courseId);
    }

    const handleChangeEnd = async (date) => {
        const formattedDate = moment(date).format('YYYY-MM-DD');
        setEndDate(formattedDate);
        await getCourseList(admin.adminId, 1, integration, startDate, formattedDate, leadsType, courseId);
    }
    

    const handleLeadsTypeChange = async (type) => {
        setLeadsType(type);
        await getCourseList(admin.adminId, 1, integration, startDate, endDate, type, courseId);
    }


    return (
        <div className="course-list-wrapper">
            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                draggable={false}
                pauseOnHover
            />

            <div className="course-list-heading">
                <Heading text="Leads List" />
                <Button  skin='dark' className="btn_post_course" text="Post Course" clickButton={() => { props.history.push('/addCourse') }} />
                {/* <a href='/courseMappingList'>
                    <Button  skin='dark' className="btn_course_mapping" text="Course Mapping" clickButton={() => { props.history.push('/courseMappingList?pageNumber=1') }}  />
                </a> */}
                <Button  skin='dark' className="btn_course_mapping" text="Course Mapping" clickButton={() => { props.history.push('/courseMappingList?pageNumber=1') }}  />

                <a href={`${process.env.REACT_APP_CLIENT_URL}/recruiter/course_admin_new.php`} target='_blank'>
                        <Button skin='dark' className="btn_use_old" disabled={false} text='Use Old Version'/>
                </a>

            </div>

                        {/* Integration Type Dropdown Filter */}
                        <div className="row">
                            <ButtonContainer heading="Filter by: ">
                                <li key="filter">
                                    <label>Integration Type</label>
                                    <Dropdown
                                        data={courseIntegrations.list}
                                        dropdownChange={onChangeFilter}
                                        defaultValue={integration}
                                    />
                                </li>
                                <li key="course-filter">
                                    <label>Course</label>
                                    <Dropdown
                                        data={courseList}
                                        dropdownChange={onChangeCourseFilter}
                                        defaultValue={courseId}
                                    />
                                </li>
                                <li key="date-filter">
                                    <label>Date</label>
                                    <FromToDatepicker startDate={startDate ? moment(startDate, 'YYYY-MM-DD').toDate() : null} endDate={endDate ? moment(endDate, 'YYYY-MM-DD').toDate() : null} handleChangeStart={handleChangeStart} handleChangeEnd={handleChangeEnd} />
                                </li>
                                {/*dropdown for type filter of 0:All Leads 1:Relevant Leads */}
                                <li key="type-filter">
                                    <label>Type</label>
                                    <Dropdown
                                        data={[{id: 0, name: 'All Leads'}, {id: 1, name: 'Relevant Leads'}]}
                                        dropdownChange={(e) => handleLeadsTypeChange(e.target.value)}
                                        defaultValue={leadsType}
                                    />
                                </li>

                            </ButtonContainer>
                        </div>

            <div className="row">
                <div className="col-md-12">
                    <p>
                       { content.count !== null && (
                            <>Total Leads: <strong>{content.count}</strong></>
                        )}
                    </p>
                </div>
            </div>

            <div className="row text-center">
            <Pagination
                    totalItemsCount={content.count}
                    content={PAGE_CONTENT}
                    pageNumber={content.pageNumber}
                    handlePageChange={(n) => handlePageChange(n)} />
            <CountDisplay start={(content.pageNumber - 1) * PAGE_CONTENT + 1} end={content.pageNumber * PAGE_CONTENT} total={content.count} />

                {fetchApiCall ? (
                  <Loader />
              ) : content.list.length ? (
                  <div className="content">
                      <Table fixed selectable className="mailers-table">
                          <Table.Header>
                              <Table.Row>
                                  <Table.HeaderCell width={4}>
                                      Date
                                  </Table.HeaderCell>
                                  <Table.HeaderCell width={4}>
                                      Name
                                  </Table.HeaderCell>
                                  <Table.HeaderCell width={6}>
                                      Organization
                                  </Table.HeaderCell>
                                  <Table.HeaderCell width={6}>
                                      Contacts
                                  </Table.HeaderCell>
                                  <Table.HeaderCell width={3}>
                                      Experience
                                  </Table.HeaderCell>
                                  <Table.HeaderCell width={3}>
                                      Actions
                                  </Table.HeaderCell>
                              </Table.Row>
                          </Table.Header>

                          <Table.Body>
                              {content.list.map((item, i) => {
                                  return (
                                      <Table.Row>
                                          <Table.Cell>
                                            {moment(item.date).format('DD-MM-YYYY hh:mm a')} <br />
                                          </Table.Cell>
                                          <Table.Cell>{item.name}</Table.Cell>
                                          <Table.Cell>
                                                <>
                                                    {item.designation} <br />
                                                    {item.organization ? (
                                                        <>
                                                            {
                                                                item.organization
                                                            }{" "}
                                                            <br />
                                                        </>
                                                    ) : null}
                                                </>
                                          </Table.Cell>
                                          <Table.Cell>
                                              {item["email"] ? (
                                                  <>
                                                      Email: {item["email"]}{" "}
                                                      <br />
                                                  </>
                                              ) : null}
                                              {item["mobile"] ? (
                                                  <>
                                                      Mobile: {item["mobile"]}{" "}
                                                      <br />
                                                  </>
                                              ) : null}
                                              {item["city"] ? (
                                                  <>City: {item["city"]} </>
                                              ) : null}
                                          </Table.Cell>

                                          <Table.Cell>
                                              {item["experience"]}
                                          </Table.Cell>

                                          <Table.Cell>
                                              {item["action"]} <br />
                                              {/* {admin["adminType"] == 3 ? (
                                                  <>
                                                      {`${
                                                          coursePlanMap[
                                                              item["plan"]
                                                          ]
                                                      } - ${item["device"]}`}
                                                  </>
                                              ) : null} */}
                                              {
                                                <>
                                                {`${
                                                    coursePlanMap[
                                                        item["plan"]
                                                    ]
                                                } - ${item["device"]}`}
                                            </>
                                              }
                                          </Table.Cell>
                                      </Table.Row>
                                  );
                              })}
                          </Table.Body>
                      </Table>
                      {/* {
                        admin['adminType'] == 3 ? (
                            <p className='course-plan'>
                                <b>
                                    Course Planing staging
                                    <br />
                                    100% = I definitely want to take this course now.
                                    <br />
                                    75% = I am definitely taking this course, not sure
                                    if I will take it now.
                                    <br />
                                    50% = Still considering. Not sure if I am going to
                                    take this course.
                                    <br />
                                    25% = I know I am going to take some course, not
                                    sure which course.
                                    <br />
                                    0% = Skip
                                </b>
                            </p>
                        ) : null */}
                        {<p className='course-plan'>
                            <b>
                                Course Planing staging
                                <br />
                                100% = I definitely want to take this course now.
                                <br />
                                75% = I am definitely taking this course, not sure
                                if I will take it now.
                                <br />
                                50% = Still considering. Not sure if I am going to
                                take this course.
                                <br />
                                25% = I know I am going to take some course, not
                                sure which course.
                                <br />
                                0% = Skip
                            </b>
                        </p>
                      }

                      
                  </div>
              ) : (
                  <div>No Records Found</div>
              )}
            </div>
        </div>
    );
};

export default LeadsList;